import { Navigate, Outlet, useLocation, useOutletContext } from "react-router-dom";
import {
  getSafeRedirectForRole,
  isPathAllowedForRole,
  normalizePathname,
  normalizeRoleId,
  ROLE,
} from "../Utils/privateRouteAccess";
import {
  getPlanRedirectPath,
  isPathAllowedByPlan,
} from "../Utils/planRouteAccess";

/**
 * Layout guard: only renders nested routes if the current path is allowed for
 * the authenticated user's role. Otherwise redirects to a safe home for that role.
 */
const PrivateRouteByRole = () => {
  const location = useLocation();
  const { userData } = useOutletContext() || {};
  const auth = userData?.data || {};
  const role = auth.role;
  const path = normalizePathname(location.pathname);
  const roleId = normalizeRoleId(role);

  if (!isPathAllowedForRole(path, role)) {
    const to = getSafeRedirectForRole(role);
    return <Navigate to={to} replace state={{ from: location }} />;
  }

  const schoolPlanRoles = [ROLE.SCHOOL_HEAD, ROLE.SCHOOL_ADMIN, ROLE.CLERK];
  if (
    schoolPlanRoles.includes(roleId) &&
    auth.plan_nav_enforced &&
    !isPathAllowedByPlan(path, auth.plan_allowed_nav_ids, true)
  ) {
    const to = getPlanRedirectPath(auth.plan_allowed_nav_ids);
    return <Navigate to={to} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default PrivateRouteByRole;
